// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"DropdownMenuButton_fullWidth__1du-i"};